import "./index.scss";
import React, { FunctionComponent } from "react";

type ButtonOptionsProps = {
  previous?: string;
  changePath: Function;
  handleSubmit: Function;
  submitText?: string;
  disabled?: boolean;
  hideOnEnterText?: boolean;
};

const renderPreviousButton = (changePath: Function, previous?: string) => {
  if (previous)
    return (
      <div className="button-wrapper">
        <button
          type="button"
          className="button previous"
          onClick={() => changePath(previous)}
        >
          <span className="mdi mdi-arrow-left"></span>Back
        </button>
      </div>
    );
};

export const ButtonOptions: FunctionComponent<ButtonOptionsProps> = ({
  previous,
  changePath,
  handleSubmit,
  submitText,
  disabled,
  hideOnEnterText,
}: ButtonOptionsProps) => (
  <div className="question-options">
    {renderPreviousButton(changePath, previous)}
    <div className="button-wrapper">
      <button
        type="submit"
        className={`button primary next ${!!disabled ? "disabled" : ""}`}
        onClick={() => handleSubmit()}
        disabled={!!disabled}
      >
        <span className="mdi mdi-check-bold"></span>
        {submitText || "OK"}
      </button>
      {!hideOnEnterText && (
        <label>
          press <strong>Enter</strong>
          <span className="mdi mdi-keyboard-return"></span>
        </label>
      )}
    </div>
  </div>
);

export default ButtonOptions;
